module.exports = __webpack_public_path__ + "static/technologies-1676ed0845e40a964dc5211159550c4e.jpg";